import { IAdFoxBannerOnLoadData } from '@cian/adfox-component';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { MortgageBannerSection } from './components';
import { AdfoxBanner } from '../../../components/AdfoxBanner';
import { selectIsAgent } from '../../../selectors';
import { useAdfoxBannerActions } from '../hooks/useAdfoxBannerActions';
import { useAdfoxPuids } from '../hooks/useAdfoxPuids';

const ADFOX_PARAMETERS = {
  p1: 'csyyh',
  p2: 'fkib',
};

export function MainMortgageBannerContainer() {
  const isAgent = useSelector(selectIsAgent);
  const adfoxPuids = useAdfoxPuids();
  const adfoxParameters = React.useMemo(
    () => ({
      ...adfoxPuids,
      ...ADFOX_PARAMETERS,
    }),
    [adfoxPuids],
  );
  const { onClick, onLoad } = useAdfoxBannerActions();

  const handleLoad = React.useCallback(
    ({ bundleParams: { bannerId } }: IAdFoxBannerOnLoadData) => {
      onLoad(bannerId);
    },
    [onLoad],
  );

  return (
    <MortgageBannerSection>
      <AdfoxBanner
        disableYan={isAgent}
        hideable={false}
        minHeight="174px"
        minWidth="148px"
        params={adfoxParameters}
        onLoad={handleLoad}
        onClick={onClick}
      />
    </MortgageBannerSection>
  );
}
